import { TypedParam } from "./_Base";
import { ParsedTree } from "../expressions/traversers/ParsedTree";
import { ParamType } from "../poly/ParamType";
import { ExpressionController } from "./utils/ExpressionController";
import { ParamEvent } from "../poly/ParamEvent";
import { CoreType } from "../../core/Type";
export class StringParam extends TypedParam {
  static type() {
    return ParamType.STRING;
  }
  defaultValueSerialized() {
    return this._default_value;
  }
  _cloneRawInput(raw_input) {
    return `${raw_input}`;
  }
  rawInputSerialized() {
    return `${this._raw_input}`;
  }
  valueSerialized() {
    return `${this.value}`;
  }
  _copyValue(param) {
    this.set(param.value);
  }
  static areRawInputEqual(raw_input1, raw_input2) {
    return raw_input1 == raw_input2;
  }
  static areValuesEqual(val1, val2) {
    return val1 == val2;
  }
  isDefault() {
    return this._raw_input == this._default_value;
  }
  convert(raw_val) {
    if (CoreType.isString(raw_val)) {
      return raw_val;
    }
    return `${raw_val}`;
  }
  rawInput() {
    return this._raw_input;
  }
  processRawInput() {
    this.states.error.clear();
    if (this._value_elements(this._raw_input).length >= 3) {
      this._expression_controller = this._expression_controller || new ExpressionController(this);
      if (this._raw_input != this._expression_controller.expression()) {
        this._expression_controller.set_expression(this._raw_input);
        this.setDirty();
        this.emitController.emit(ParamEvent.EXPRESSION_UPDATED);
      }
    } else {
      if (this._raw_input != this._value) {
        this._value = this._raw_input;
        this.removeDirtyState();
        this.setSuccessorsDirty(this);
        this.emitController.emit(ParamEvent.VALUE_UPDATED);
        this.options.executeCallback();
        if (this._expression_controller) {
          this._expression_controller.set_expression(void 0, false);
          this.emitController.emit(ParamEvent.EXPRESSION_UPDATED);
        }
      }
    }
  }
  async processComputation() {
    var _a;
    if (((_a = this.expressionController) == null ? void 0 : _a.active()) && !this.expressionController.requires_entities()) {
      const expression_result = await this.expressionController.computeExpression();
      if (this.expressionController.is_errored()) {
        this.states.error.set(`expression error: ${this.expressionController.error_message()}`);
      } else {
        const converted = this.convert(expression_result);
        if (converted != null) {
          this._value = converted;
          this.emitController.emit(ParamEvent.VALUE_UPDATED);
          this.options.executeCallback();
        } else {
          this.states.error.set(`expression returns an invalid type (${expression_result})`);
        }
        this.removeDirtyState();
      }
    }
  }
  _value_elements(v) {
    return ParsedTree.string_value_elements(v);
  }
}
